// Half-open [startInclusive, endExclusive) → the inclusive end date
// (endExclusive - 1 day), shared by every surface that stores a supplier
// factor / draft / request interval but displays or seeds an inclusive end
// date (adapters.js, supplierDraftPresentation.js, supplierInboxPresentation.js,
// RevisionHistoryModal.jsx). Mirrors the backend storing lastRecordDate =
// endExclusive - 1ms. Returns '' when endExclusive is missing/invalid.
export const inclusiveEndDateFromExclusive = (endExclusive) => {
  if (!endExclusive) return '';
  const d = new Date(endExclusive);
  if (Number.isNaN(d.getTime())) return '';
  d.setUTCDate(d.getUTCDate() - 1);
  return d.toISOString().slice(0, 10);
};
